<template>
  <section id="page-login">
    <div class="container">
      <div class="row">

        <clearfix :biggest="true"></clearfix>

        <div class="col-sm-12 content fb-bg-light">
          <div class="cubix-form">
            <label for="field-login">login:&nbsp;</label><br>
            <input id="field-login" v-model="form.login" placeholder="User id:" type="text"/><br>
            <label for="field-passwd"><span v-if="form.login.length >= 4">hello {{ form.login }}, enter your&nbsp;</span>password:&nbsp;</label><br>
            <input id="field-passwd" v-model="form.passwd" placeholder="Password:" type="password"/><br>

            <div v-if="form.login.length >= 4 && form.passwd.length > 4" class="control">
              good .. now <a href="#" class="control button" @click.prevent="submitLogin">log in</a>
            </div>
          </div>

          <clearfix :wide="true"></clearfix>
        </div>

        <clearfix :biggest="true"></clearfix>
      </div>
    </div>
  </section>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Clearfix from '@/components/utils/Clearfix'
  import config from '@/components/utils/Config'

  Vue.use(VueAxios, axios)

  export default {
    data () {
      return {
        form: {
          login: '',
          passwd: ''
        }
      }
    },
    methods: {
      submitLogin () {
        Vue.axios.get(config.urls.login, {
          auth: {
            'username': this.form.login,
            'password': this.form.passwd
          }
        })
        .then((response) => {
          this.$store.commit('setJwt', response.headers.authorization)
          Vue.axios.defaults.headers.common['Authorization'] = response.headers.authorization
          this.$router.push('/')
        })
      }
    },
    components: {
      Clearfix
    }
  }
</script>

<style>
  #page-login {
    background: url('../../assets/img/bg/coding.jpg') center fixed no-repeat;
    background-size: cover;
    height: auto;
    margin: 0 auto;
    width: 100%;
    position: relative;
    padding: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// LoginForm.vue?77e442f0